import React, { useState, useContext, useEffect } from "react";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { DateRangePicker } from "react-date-range";
import { intelliegenceContext } from "../../../states/context/intelliegenceContext";
import { updateFitBounds } from "../../../utils/map";
import moment from "moment";
import { addDays } from "date-fns";
import { getGlobalRisksData } from "../../../services/api.service";
import './CalenderButton.css';

const CalenderButton = () => {
  const context = useContext(intelliegenceContext);
  const styles = useStyles();
  const [open, setOpen] = useState(false);
  const todayDate = new Date();

  const [dateState, setDateState] = useState({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
    compare: {
      startDate: new Date(),
      endDate: new Date(),
      key: "compare",
    },
  });

  const dateFn = (start_date, end_date) => {
    const dateLabel = moment(context.markerPayload.start_date).calendar(null, {
      // when the date is closer, specify custom values
      lastWeek: `${start_date === end_date
          ? "[Last] dddd"
          : `[${moment(context.markerPayload.start_date).format(
            "ddd,D YYYY"
          )} - ${moment(context.markerPayload.end_date).format("ddd,D YYYY")}]`
        }`,
      lastDay: "[Yesterday]",
      sameDay: "[Today]",
      // when the date is further away, use from-now functionality
      sameElse: function (now) {
        const startDate = moment(context.markerPayload.start_date).format(
          "ddd,D YYYY"
        );
        const endDate = moment(context.markerPayload.end_date).format(
          "ddd,D YYYY"
        );
        const label = `${startDate} - ${endDate}`;
        return `[${label}]`;
      },
    });
    context.setTimeWindowLabel(dateLabel);
  };

  const handleOnchange = (item) => {
    setDateState({ ...dateState, ...item });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDateState({
      selection: {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
      compare: {
        startDate: new Date(),
        endDate: new Date(),
        key: "compare",
      },
    });
  };

  const handleSearch = async () => {
    const _drawer = context.drawer;
    const maxDate = dateState.compare.endDate;

    _drawer.filter = false;
    handleClose();
    // context.setLoaderStatus(true);
    context.setDrawer(_drawer);

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startDateWithUTC = toTimeZone(
      dateState.selection.startDate,
      timezone
    ).replaceAll("/", "-");
    let endDateWithUTC = toTimeZone(
      dateState.selection.endDate,
      timezone
    ).replaceAll("/", "-");

    if (dateState.selection.endDate > maxDate) {
      endDateWithUTC = toTimeZone(
        dateState.compare.endDate,
        timezone
      ).replaceAll("/", "-");
    }

    endDateWithUTC = moment(dateState.selection.endDate).format('YYYY-MM-DDT23:59:59');

    const { meta, data } = await getMarkerData(
      startDateWithUTC,
      endDateWithUTC
    );

    if (meta.status !== 200) return;
    // context.setLoaderStatus(false);

    const markers = updateFitBounds(data.marker_location);
    context.setMapLocation(data.map_location);
    context.setMarkerLocation(markers);
    // context.setLoaderStatus(false);

    let start_date = moment.utc(context.markerPayload.start_date).fromNow();
    let end_date = moment.utc(context.markerPayload.end_date).fromNow();
    dateFn(start_date, end_date);
  };

  function toTimeZone(time, zone) {
    const format = "YYYY/MM/DDTHH:mm:ss";
    return moment(time, format).tz(zone).format(format);
  }

  const getMarkerData = async (startDateWithUTC, endDateWithUTC) => {
    const markerPayLoad = context.markerPayload;
    markerPayLoad["start_date"] = startDateWithUTC;
    markerPayLoad["end_date"] = endDateWithUTC;
    dateFn(startDateWithUTC, endDateWithUTC);
    context.setMarkerPayload(markerPayLoad);
    const payLoad = {
      api_name: "public_risk_marker",
      data: markerPayLoad,
    };

    const data = await getGlobalRisksData(payLoad);
    context.setMarkerPayload(markerPayLoad);
    return data;
  };

  return (
    <div>
      <h3 className={styles.timeWindow}>Time Window</h3>
      <Grid item xs={12} className={styles.timeWindowBtn}>
        <CardActions>
          <Button variant="contained" size="small" onClick={handleClickOpen}>
            {/* {
                            context.markerPayload.start_date.split('T')[0] === context.markerPayload.end_date.split('T')[0] ?
                                context.markerPayload.start_date.split('T')[0] : `${context.markerPayload.start_date.split('T')[0]} - ${context.markerPayload.end_date.split('T')[0]}`
                        } */}
            {/* {
                            context.markerPayload.start_date.split('T')[0] === context.markerPayload.end_date.split('T')[0] ?
                            "Today" : `${moment.utc(context.markerPayload.start_date).fromNow()}`
                        } */}
            {context.timeWindowLabel}
          </Button>
          <div>
            <Dialog
              onClose={handleClose}
              aria-labelledby="customized-dialog-title"
              open={open}
              className={styles.timdeModal}
            >
              <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                Select a custom date range
                <IconButton aria-label="close" onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <DateRangePicker
                  onChange={(item) => handleOnchange(item)}
                  months={1}
                  ranges={[dateState.selection, dateState.compare]}
                  direction="horizontal"
                  rangeColors={["black"]}
                  inputRanges={[]}
                  maxDate={addDays(new Date(), 0)}
                  // minDate={new Date(thisYear, minMonth)}
                  minDate={new Date(todayDate.getTime() - (30 * 24 * 60 * 60 * 1000))}
                  isClearable={true}
                // onPreviewChange={item => console.log("xxx==>",item)}
                />
              </DialogContent>
              <DialogActions className={styles.modalAction}>
                <Button autoFocus onClick={handleSearch} color="primary">
                  Search
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </CardActions>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  timeWindow: {
    margin: "0px",
    fontFSamily: "Inter",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "14px",
  },
  timeWindowBtn: {
    "& Button": {
      backgroundColor: "#363740",
      color: "#FFFFFF",
      fontSize: 12,
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "500",
    },
    "& .MuiButton-root:hover": {
      backgroundColor: "#363740",
    },
    "& .MuiCardActions-root": {
      padding: "1px 8px 8px 0px",
    },
    "& .MuiButton-root": {
      textTransform: "none",
    },
  },
  timdeModal: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "100%",
    },
    "& .MuiTypography-h6": {
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "bold",
      fontSize: 24,
    },
    "& .MuiDialogContent-root": {
      padding: 0,
    },
    "& .MuiDialogTitle-root": {
      padding: "16px 16px",
    },
    "& .rdrDateDisplay:last-child": {
      display: "none",
    },
  },
  modalAction: {
    "& Button": {
      backgroundColor: "#363740",
      color: "#FFFFFF",
      fontSize: 12,
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "500",
    },
    "& .MuiButton-root:hover": {
      backgroundColor: "#363740",
    },
  },
}));

export default CalenderButton;
